import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { setTheme } from '../../shared/const';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class Themeservice {
  private themes = ['morden', 'classic', 'dark', 'light'];
  private currentTheme = 'morden';
  themeSubject = new BehaviorSubject<string>('');
  theme$ = this.themeSubject.asObservable();

  constructor(private http: HttpClient) {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme && this.themes.includes(savedTheme)) {
      this.currentTheme = savedTheme;
    }
    this.setTheme(this.currentTheme);
  }

  getCurrentTheme(): string {
    return this.currentTheme;
  }

  setTheme(theme: string): void {
    localStorage.setItem('theme', theme);
    document.body.className = theme;  
    this.currentTheme = theme;
    this.themeSubject.next(theme);
  }

  getThemes(): string[] {
    return this.themes;
  }

  getTheme() {
    return this.themeSubject.value;
  }

  updateTheme(theme: any) {
    return this.http.post<any>(`${setTheme}`, theme);
  }
}
